import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import API from '../../../app/api';
import _ from 'lodash';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import AdmissionPatientCard from '../admissionPatientCard';
import {
    getAdmissionType,
    getConfig,
    loadUnscheduledOperationsWithOperationOnList,
    setAdmissionType, setFiltersStatus,
    setMarkedOperation, setNewAdmissionType,
    setNewView,
    setNextUnscheduledOperationsData,
    setOperationsStatus,
    setOperationToScroll,
    setSelectedTheatre, setTheatreById,
} from '../../../store/reducers/booked_admissions';
import {admissionStatusTypes, admissionViewTypes, CalendarViews} from '../bookedAdmissions';
import clsx from 'clsx';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Divider} from '@mui/material';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import {Add} from '@mui/icons-material';
import {useHistory} from 'react-router-dom';
import {agylePref} from '../../../store/reducers/preferences';
import {StatusTypes} from '../patientsLists/patientsList';
import {useDebounce} from 'use-debounce';
import LoadingButton from "@mui/lab/LoadingButton";
import {setSnackbar} from '../../../store/reducers/globals';

const useStyles = makeStyles((theme) => ({

    dropdownSearch: {
        position: "absolute",
        left: "108px",
        top: "50px",
        background: theme.palette.accordion.backgroundColorRefresh,
        border: "1px solid white",// +  theme.palette.background.paper,
        borderTop: "1px solid "+theme.palette.background.dialog,
        width: "calc(100vw - 68px - 55px - 58px)",
        zIndex: 1010,
        maxHeight: 600,
        overflow: "auto",
        borderRadius: "0 0 10px 10px",
        padding: 10
    },
    emptySearch: {

    },
    text: {
      fontSize: 12
    },
    patientItem: {
        margin: "5px",
        padding: "10px",
        background: theme.palette.mode === "dark" ? "#3D3E40" : "#FFFFFF",
        // "&:hover": {
        //     background: theme.palette.mode === "dark" ? "#3D3E40" : "#e3e3e3",
        // },
        borderRadius: "10px",
        minHeight: "55px",
        display: "flex",
        alignItems: "center",
        fontSize: "12px",
        fontWeight: "bold"
    },
    label: {
        color: "grey",
        fontWeight: "normal",
    },
    data: {
    },
    openIcon: {
        justifyContent: "center",
        display: "flex",
        alignItems: "center"
    },
    backdropSearch: {
        position: "absolute",
        width: "100%",
        height: "calc(100%)",
        top: "0px",
        zIndex: 1009,
        left: "0",
        background: "#252525c4"
    }
}));

const PatientsSearch = (props) => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();

    const [totalAudits, setTotalCounter] = React.useState(0);
    const [pagesCount, setPagesCount] = React.useState(0);
    const [cardConfig, setCardConfig] = React.useState();
    const [patients, setPatients] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [loadingPatients, setLoadingPatients] = React.useState(false);
    const [openAdmissions, setOpenAdmissions] = React.useState({});

    const config = useSelector(getConfig);
    const admissionType = useSelector(getAdmissionType);
    const agylePreference = useSelector(agylePref);


    const loadPatientList = () => {
        if(props.searchPhrase !== "") {
            API.getSearchList({
                resourceUri: "/patients",
                text: props.searchPhrase,
                page: 1,
                pageSize: 20,
                options: {}
            }).then(res => {
                if (res.status === 200) {
                    setPatients(_.filter(res.data.collection['__data'], p => !_.isNull(p)));
                    setTotalCounter(res.data.collection['__size']);
                    setPagesCount(res.data.collection['__pageCount']);
                }
                if (res.status === 204) setPatients([]);
                if (res.status !== 200 && res.status !== 204) {
                    console.debug("API.getPatientsList request status : " + res.status);
                }
            }).finally(() =>{
                setLoadingPatients(false)
            });
        } else {
            setPatients([]);
        }
    }

    useEffect(() => {
        _.forEach(patients, (patient) => {
            let patientMergedNumbers = [];
            _.forEach(patient.patientNumbers, (nbrs) => {
                if(nbrs.hasOwnProperty("type") && nbrs.type != null && nbrs.type.length > 0) {
                    if (nbrs.type.toUpperCase() == "MERGED") {
                        patientMergedNumbers.push(nbrs.number);
                    }
                }
            });
            if(patientMergedNumbers.indexOf(props.searchPhrase) >= 0){
                dispatch(setSnackbar({
                    type: 'info',
                    message: "Found patient record number " + patient.hospitalNumber + " merged with number " + props.searchPhrase,
                }));
            }
        })
    }, [patients])

    useEffect(() => {
        setLoadingPatients(props.searchPhrase !== "")
        const getPatientListTimeOut = setTimeout(() => {
            if(props.searchPhrase !== "") {
                loadPatientList()
            } else {
                setPatients([]);
            }
            }, 1000)


        return () => clearTimeout(getPatientListTimeOut)

    },[props.searchPhrase])


    const getOperationData = (id) => {
        let patientsTmp = patients;

        let opTypeFilter = '["TCI","MDU"]';
        let filter = `patientId in '["${id}"]'`

        filter += `and opType in '${opTypeFilter}'`;

        setLoading(true);
        API.getOperation(filter).then(data => {

            let index = _.findIndex(patients, {hospitalNumber: id});
            patientsTmp[index]["operations"] = [];

            data.forEach((op) => {
                patientsTmp[index]["operations"].push(op);
            })

            setPatients(patientsTmp);
            setLoading(false);

        }).catch(function (error) {
            // TODO: error handler !!!
            setLoading(false);
            console.error(error);
        });
    }

    const handleOpenAdmissions = (hospitalNumber, index) => {
        if(!openAdmissions[hospitalNumber])
            getOperationData(patients[index].hospitalNumber);

        setOpenAdmissions((openAdmissionsPrev) => {
           return {
               ...openAdmissionsPrev,
               [hospitalNumber]: !openAdmissionsPrev[hospitalNumber]
           }
        })
    }



    useEffect(()=> {
        if(config) {
            let configType = "search";
            let configCard = config.cardSetting[configType];

            if(agylePreference.bookedAdmissionsCardConfig[configType])
                configCard = agylePreference.bookedAdmissionsCardConfig[configType]

            setCardConfig(configCard);
        }

    },[config, agylePreference])

    const handleOperationClick = (operation) => {

        //MDU
            //unscheduled active
            //unscheduled cancel
            //scheduled
        //TCI
            //unscheduled active
            //unscheduled cancel
            //scheduled
            //worklist

        let admissionTypeNew = operation.opType === "MDU"? admissionViewTypes.MDU: admissionViewTypes.THEATRES;

        if(admissionTypeNew === admissionViewTypes.THEATRES && operation.status === "WORKLIST"){
            handleHideDropdown()
            dispatch(setOperationsStatus(admissionStatusTypes.WORKLIST))
        } else {
            if(admissionTypeNew !== admissionType) {
                dispatch(setNewAdmissionType(admissionTypeNew))
                dispatch(loadUnscheduledOperationsWithOperationOnList(admissionTypeNew, operation));
            } else if(!operation.bookedSession){
                if(operation.cancelInfo && operation.cancelInfo.status === "delete"){
                    dispatch(setFiltersStatus(StatusTypes.CANCELED))
                } else {
                    dispatch(setFiltersStatus(StatusTypes.ACTIVE))
                }
                dispatch(setNextUnscheduledOperationsData([operation]));
            }

            if(!operation.bookedSession){
                handleHideDropdown()
                dispatch(setOperationsStatus(admissionStatusTypes.UNSCHEDULED))
                dispatch(setMarkedOperation(operation));
                dispatch(setOperationToScroll(operation.id));
                dispatch(setNewView(moment().startOf("month"), CalendarViews.month));
            } else {
                API.getSesionsByIds([operation.bookedSession]).then(data => {
                    handleHideDropdown()
                    dispatch(setOperationsStatus(admissionStatusTypes.SCHEDULED))
                    let session = data.__data[0];
                    dispatch(setTheatreById(session.theatre.__id))
                    dispatch(setNewView(moment(session.day), CalendarViews.days1));
                    dispatch(setMarkedOperation({
                        ...operation,
                        sessiosObj: session
                    }));
                    dispatch(setOperationToScroll(operation.id))

                }).catch(function (error) {
                    // TODO: error handler !!!
                    console.error(error);
                });
            }
        }


    }

    const renderAdmissionRow = (operation) => {
        return <div style={{width: "100%", marginBottom: 10}} onClick={() => handleOperationClick(operation)}>
                {/*{operation.opType} | {operation.status} | {operation.bookedSessions? "BOOKED": "UNSCHEDULE"} | {operation.cancelInfo? operation.cancelInfo.status:"" }*/}
                <AdmissionPatientCard ad={operation}
                                      hourHeight = {200}
                                      cardConfig={cardConfig}
                                      extraKey={"_s"} index={"index"}/>
            </div>
    }


    const renderPatientRow = (patient, index) => {
        return <div className={classes.patientItem}>
            <Grid container spacing={1} alignItems={"center"}>
                <Grid item xs={2}>
                  <div className={classes.label}>Patient Name </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.label}> Hospital Number </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.label}> Dob </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.label}> NHS number </div>
                </Grid>
                <Grid item xs={1}>
                    <div className={classes.label}> Gender </div>
                </Grid>
                <Grid item xs={3} >
                </Grid>

                <Grid item xs={2}>
                    <div className={classes.data}> {patient.firstName} {patient.familyName} </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.data}> {patient.hospitalNumber} </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.data}> {moment(patient.dob).format("DD/MM/YYYY")} </div>
                </Grid>
                <Grid item xs={2}>
                    <div className={classes.data}> {patient.nhsNumber} </div>
                </Grid>
                <Grid item xs={1}>
                    <div className={classes.data}> {patient.gender} </div>
                </Grid>
                <Grid item xs={2}>
                    <div style={{float: "right"}}>
                        <AgyleButton
                            onClick={()=>{
                                history.push("/createBookAdmission/"+patient.hospitalNumber.replace("/","_$_")+"/new");
                            }}
                            size={"small"}
                            startIcon={<Add/>}
                            variant={"contained"}
                        >
                            Admission
                        </AgyleButton>
                    </div>

                </Grid>
                <Grid item xs={1} onClick={() => handleOpenAdmissions(patient.hospitalNumber, index)}>
                    <div className={classes.openIcon}>
                        {openAdmissions[patient.hospitalNumber]? <KeyboardArrowUpIcon/>:<KeyboardArrowDownIcon/>}
                    </div>
                </Grid>
                {openAdmissions[patient.hospitalNumber] &&
                    <Grid xs={12} item>
                        <div style={{maxHeight: 300, overflow: "auto"}} className={"scroll-normal-white"}>
                            <Divider style={{marginBottom: 10}}/>
                            <Grid container>
                                {patient.operations?.map((operation) => {
                                    return renderAdmissionRow(operation)
                                })}
                            </Grid>
                        </div>


                    </Grid>
                }

            </Grid>
        </div>
    }

    const handleHideDropdown = () => {
        if(props.openSearchModal) props.openSearchModal(false)
    }

    useEffect(()=>{
        if(!props.open) {
            setOpenAdmissions({})
        }
    },[props.open])


    const [page, setPage] = React.useState(1);


    const handleScrollList = (e) => {
            const isBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 800; // e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
            if (isBottom && !loading) {
                setLoading(true);
                setPage((page) => (page + 1));
            }
    }

    return <div>
        <div style={{display: props.open? "block": "none"}}>
            <div className={classes.backdropSearch} onClick={handleHideDropdown}/>
            <div className={clsx(classes.dropdownSearch, patients?.length === 0 && classes.emptySearch)} >
                <div className={"scroll-normal-white"}>
                    {patients?.map((p, index)=>{
                        return renderPatientRow(p, index);
                    })}
                </div>
                {props.searchPhrase === "" && !loadingPatients && <div className={classes.text}>
                    Please enter your search criteria
                </div>
                }
                {patients?.length === 0 && props.searchPhrase !== "" && !loadingPatients && <div className={classes.text}>
                    Unfortunately we cannot find what you are looking for. Please adjust your search criteria
                </div>
                }
                {loadingPatients && <div className={classes.text}> Loading... </div>}
            </div>
        </div>

    </div>

}

export default PatientsSearch;